import { i18n } from '@lingui/core'
import { Button } from '@mui/material'
import { useState } from 'react'
import { AddReviewModal } from './AddReviewModal'

export type AddReviewProps = {
  productLink?: string
  productName?: string | null | undefined
  productId?: string
  thumbnail?: any
  customer?: any
  orderId?: string | undefined
}

export function AddReview(props: AddReviewProps) {
  const { productLink, productName, productId, thumbnail, customer, orderId } = props
  const [displayProofModal, setDisplayProofModal] = useState<boolean>(false)

  const hasReview = true

  return (
    <div className='mb-1 flex items-center justify-center lg:mb-3'>
      <Button
        variant='outlined'
        color='primary'
        size='small'
        className='w-full rounded-[5px] bg-pure-white uppercase'
        onClick={() => setDisplayProofModal(true)}
      >
        {hasReview ? i18n._('Leave a review') : i18n._('Modify review')}
      </Button>
      <AddReviewModal
        isDisplayed={displayProofModal}
        setIsDisplayed={setDisplayProofModal}
        productLink={productLink}
        productName={productName}
        productId={productId}
        thumbnail={thumbnail}
        customer={customer}
        orderId={orderId}
      />
    </div>
  )
}
